import { render, staticRenderFns } from "./DoctorProfileReport.vue?vue&type=template&id=1c34eb73"
import script from "./DoctorProfileReport.vue?vue&type=script&lang=js"
export * from "./DoctorProfileReport.vue?vue&type=script&lang=js"
import style0 from "./DoctorProfileReport.vue?vue&type=style&index=0&id=1c34eb73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports